export default __webpack_public_path__ + "static/chamonix-france-d717952bfb0c29f98f2efb15d3edce50.jpg";